<script setup lang="ts">
import type { BaseButtonProps } from '@/components/button/base-button.vue';

import BaseButton from '@/components/button/base-button.vue';

type Props = Omit<BaseButtonProps, 'color'> & {
   variant?: 'solid' | 'outline';
};

const props = defineProps<Props>();
</script>

<template>
   <BaseButton v-bind="props" color="gradient">
      <slot />
   </BaseButton>
</template>

<style scoped>

</style>
